export enum DialogIds {
  ClipboardDialog = 'ClipboardDialog',
  WelcomeTourDialog = 'WelcomeTourDialog',
  JoinDomainDialog = 'JoinDomainDialog',
  NpsSurveyDialog = 'NpsSurveyDialog',
  ConfirmDialog = 'ConfirmDialog',
  LimitDialog = 'LimitDialog',
  UpgradeDialog = 'UpgradeDialog',
  BuyDialog = 'BuyDialog',
  ProfileDialog = 'ProfileDialog',
  SaveModuleDialog = 'SaveModuleDialog',
  SaveBookmarkDialog = 'SaveBookmarkDialog',
  SaveAsBookmarkDialog = 'SaveAsBookmarkDialog',
  ManageDialog = 'ManageDialog',
  BookmarkAccessDialog = 'BookmarkAccessDialog',
  GroupRestrictionDialog = 'GroupRestrictionDialog',
  PremiumContentDialog = 'PremiumContentDialog',
  AboutDialog = 'AboutDialog',
  ImportDialog = 'ImportDialog',
  AddTeamModelDialog = 'AddTeamModelDialog',
  ImageDialog = 'ImageDialog',
  QuizSettingsDialog = 'QuizSettingsDialog'
}
